import { render, staticRenderFns } from "./PaymentInstructionOptionsButton.vue?vue&type=template&id=13cba2c6&"
import script from "./PaymentInstructionOptionsButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionOptionsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports